import { createSlice } from "@reduxjs/toolkit";
import {
  addVendor,
  deleteVendor,
  getVendors,
  updateVendor,
} from "./actions/vendorActions";

const initialState = {
  vendor: null,
  vendors: null,
  total: 0,
  loading: false,
  isEditing: false,
};

export const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    setVendor: (state, action) => {
      const vendor = state.vendors.find(
        (_vendor) => _vendor.id === action.payload
      );
      state.vendor = vendor;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVendors.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendors.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(getVendors.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addVendor.pending, (state) => {
        state.loading = true;
      })
      .addCase(addVendor.fulfilled, (state, action) => {
        state.loading = false;
        window.location.hash = "#/profile/vendor";
      })
      .addCase(addVendor.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateVendor.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.isEditing = false;
        state.vendor = action.payload;
      })
      .addCase(updateVendor.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(deleteVendor.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVendor.fulfilled, (state) => {
        state.loading = false;
        window.location.hash = "#/profile/vendor";
      })
      .addCase(deleteVendor.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setVendor, setIsEditing } = vendorSlice.actions;

export default vendorSlice.reducer;
